import domready from 'domready'
import 'cookieconsent'
import $ from 'jquery'

function addReadMoreButton (href, cookieconsent) {
  const popupElement = document.querySelector('.cc-window')
  if (popupElement) {
    const closeButton = $('<button aria-label="dismiss cookie message" role="button" tabindex="0" class="cc-close-button cc-close"><span>Close</span></button>')[0]
    popupElement.appendChild(closeButton)

    const complianceElement = popupElement.querySelector('.cc-compliance')
    if (complianceElement) {
      const readMoreLink = `<a aria-label="read more about cookies" role="button" tabindex="0" class="cc-btn" href="${href}">Read more</a>`
      complianceElement.innerHTML = readMoreLink + complianceElement.innerHTML
    }
    const originalLinkElement = popupElement.querySelector('.cc-message .cc-link')
    if (originalLinkElement) {
      originalLinkElement.parentElement.removeChild(originalLinkElement)
    }
  }
}

export default function initCookieConsent () {
  domready(() => {
    console.log(window.cookieconsent)
    const cc = window.cookieconsent.initialise({
      // palette: {
      //   popup: {
      //     background: '#ffffff',
      //     text: '#101010'
      //   },
      //   button: {
      //     background: 'transparent',
      //     text: '#101010'
      //   }
      // },
      position: 'bottom-right',
      // type: 'opt-in',
      content: {
        dismiss: 'I understand',
        message: 'We use cookies for functional and analytical purposes.',
        showLink: false
      },
      onInitialise: function (status) {
        console.log('onInitialise', arguments)
      },
      onStatusChange: function (status, chosenBefore) {
        console.log('onStatusChange', arguments)
      },
      onRevokeChoice: function () {
        console.log('onRevokeChoice', arguments)
      },
      onPopupOpen: function () {
        addReadMoreButton('/privacy-policy')
      }
    })
    console.log('cc', cc)
    console.log('cc', window.cookieconsent)
    // cc.on('initialized', (...args) => console.log(args))
    // cc.on('error', console.error)
    // cc.on('popupOpened', () => console.log('Popup Open'))
    // cc.on('popupClosed', () => console.log('Popup Closed'))
    // cc.on('revokeChoice', () => console.log('Popup Reset'))
    // cc.on('statusChanged', (...args) => console.log(args))
  })
}
